var OrderStatus = {
  TBV: 10, // A valider
  NEW: 0, // Nouvelle
  WAITING_INFO: 7, // En attente d'infos
  PENDING: 1, // En préparation
  SENDING: 6, // En cours de livraison
  SENT: 2, // Livrée
  PARTIALLY_DELIVERED: 3, // Partiellement livré
  BLOCKED: 4, // En reliquat
  CANCELED: 5, // Annulée
};

module.exports = OrderStatus;
